import { DateTime } from 'luxon';
import { LicenseTerm } from './LicenseTerm';
import { LicenseTypeEnum } from '../licences/LicenseType';

export type AddLicenseTerm = Omit<LicenseTerm, 'id'>;

export const defaultAddLicenseTerm: AddLicenseTerm = {
    licenseType: LicenseTypeEnum.Commercial,
    notes: '',
    downloadUrl: '',
    startDate: DateTime.fromISO(''),
    endDate: DateTime.fromISO(''),
};
